export const REVIEWS_PROGRAM_REQUEST = "REVIEWS_PROGRAM_REQUEST";
export const REVIEWS_PROGRAM_SUCCESS = "REVIEWS_PROGRAM_SUCCESS";
export const REVIEWS_PROGRAM_FAIL = "REVIEWS_PROGRAM_FAIL";
